import ApiUtil from './api';

class WalletApi extends ApiUtil {

  getOrCreateWallet(params) {
    return this.post('/user/wallet', {
      data: JSON.stringify(params),
    });
  }

  sendOtp(params) {
    return this.post('/user/wallet/send-otp', {
      data: JSON.stringify(params),
    });
  }

  verifyOtp(params) {
    return this.post('/user/wallet/verify-otp', {
      data: JSON.stringify(params),
    });
  }

  getBalance(params) {
    const queryString = `?chainId=${params.chainId}`;
    return this.get(`/user/wallet/balance${queryString}`);
  }

  getNonce(params) {
    const queryString = `?chainId=${params.chainId}`;
    return this.get(`/user/wallet/nonce${queryString}`);
  }

  transferEstimateGas(params) {
    return this.post(`/user/wallet/transfer-estimate-gas`, {
      data: JSON.stringify(params),
    });
  }

  transfer(params) {
    return this.post(`/user/wallet/transfer`, {
      data: JSON.stringify(params),
    });
  }
}

export default new WalletApi();
